import { Reducer } from 'redux';
import { OrganisationUserState, OrganisationUserActionTypes } from 'types';

const initialState: OrganisationUserState = {
  errors: null,
  users: [],
  loadingUsers: false,
  isModelOpen: false,
  isDeleting: false,
  submitting: false,
  success: false,
  userAdded: false,
  userDeleted: false
};

const reducer: Reducer<OrganisationUserState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_START:
      return {
        ...state,
        loadingUsers: true
      };
    case OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_SUCCESS:
      return {
        ...state,
        loadingUsers: false,
        users: action?.payload?.Users.map(
          ({
            firstName,
            email,
            lastName,
            lastLoggedInAt,
            id,
            role,
            OrganisationUser
          }: any) => ({
            firstName,
            lastName,
            emailAddress: email,
            lastLoggedInAt: lastLoggedInAt,
            id,
            role: OrganisationUser?.role || role
          })
        )
      };
    case OrganisationUserActionTypes.FETCH_USERS_BY_ORG_ID_FAILURE:
      return {
        ...state,
        loadingUsers: false,
        errors: action.error
      };
    case OrganisationUserActionTypes.ADD_USERS_TO_ORG_SUCCESS: {
      return {
        ...state,
        submitting: false,
        success: true,
        userAdded: true
      };
    }
    case OrganisationUserActionTypes.ADD_USERS_TO_ORG_FAILURE:
      return {
        ...state,
        errors: action.error,
        submitting: false,
        success: false
      };
    case OrganisationUserActionTypes.ADD_USERS_TO_ORG_START:
      return {
        ...state,
        isModelOpen: action.payload,
        submitting: true,
        userAdded: false
      };
    case OrganisationUserActionTypes.OPEN_ADD_ADMINISTRATOR_MODAL_START:
      return {
        ...state,
        isModelOpen: action.payload,
        success: false
      };
    case OrganisationUserActionTypes.DELETE_USERS_TO_ORG_START:
      return {
        ...state,
        isDeleting: true,
        userDeleted: false
      };
    case OrganisationUserActionTypes.DELETE_USERS_TO_ORG_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        userDeleted: true
      };
    case OrganisationUserActionTypes.DELETE_USERS_TO_ORG_FAILURE:
      return {
        ...state,
        errors: action.error,
        isDeleting: false
      };
    case OrganisationUserActionTypes.REMOVE_ERROR:
      return {
        ...state,
        errors: null
      };
    case OrganisationUserActionTypes.RESET_USER_ADDED_FLAG:
      return {
        ...state,
        userAdded: false
      };
    case OrganisationUserActionTypes.RESET_USER_DELETED_FLAG:
      return {
        ...state,
        userDeleted: false
      };
    default: {
      return state;
    }
  }
};

export { reducer as OrganisationUserReducer };
